import { render, staticRenderFns } from "./resourceDetailAllocationUser.vue?vue&type=template&id=8d6acaa8&scoped=true"
import script from "./resourceDetailAllocationUser.vue?vue&type=script&lang=js"
export * from "./resourceDetailAllocationUser.vue?vue&type=script&lang=js"
import style0 from "./resourceDetailAllocationUser.vue?vue&type=style&index=0&id=8d6acaa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d6acaa8",
  null
  
)

export default component.exports